import App from "../../models/app/app.model";
import { Collections, CollectionsClass } from "../../utils/firestore/collections";
import { AppDispatch } from "../store";
import * as AppReducer from "./reducer";
import { doc, getDoc } from "firebase/firestore";

const docRef = doc(CollectionsClass.instance, Collections.APP, "Initialize");

class AppAction {
    static getAppData = (
        dispatch: AppDispatch
    ) => {
        getDoc(docRef)
            .then((res) => dispatch(AppReducer.setAppData(res.data() as App)))
            .catch((e) => console.log("ERROR:", e));
    }

    static setOnboarded = (
        value: boolean,
        dispatch: AppDispatch
    ) => {
        dispatch(AppReducer.setOnboarded(value));
    }
}

export default AppAction;